import createRoutine from '@/utils/createRoutine'

export const sidebarRoutine = createRoutine('sidebarRoutine')

export const sidebarGetters = {
  SIDEBAR_STATUS: 'SIDEBAR_STATUS'
}

export const SIDEBAR_CLEANUP = 'SIDEBAR_CLEANUP'
